import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CommentsComponent } from './comments.component';
import { HtmlEditorModule } from '../html-editor/html-editor.module';
import { AvatarModule } from '../avatar/avatar.module';
import { PipesModule } from '../../pipes/pipes.module';
import { LoadingButtonComponent } from '../loading-button/loading-button.component';
import { LinkPreviewComponent } from '../link-preview/link-preview.component';

@NgModule({
  declarations: [
    CommentsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    HtmlEditorModule,
    AvatarModule,
    PipesModule,
    LoadingButtonComponent,
    LinkPreviewComponent
  ],
  exports: [
    CommentsComponent
  ]
})
export class CommentsModule { } 